import CustomCard from "../../../../../components/CustomCard";
import {
    IconMealBowl,
    PlusIconsOptions
} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Available cafeteria (diner) card for the foodie shift Add tab. Shows the
 * cafeteria name with an add action. Mirrors the attendance DevicesCard.
 *
 * @param {Object} props
 * @param {Object} props.item - Cafeteria row ({ [keyId], fullName, disabled }).
 * @param {Function} props.onAdd - Callback invoked with the item when added.
 * @returns {JSX.Element}
 */
const CafeteriaCard = ({ item, onAdd }) => {
    return (
        <>
            <CustomCard
                classes="w-100"
                classCard="card-border-8px"
                classContent={`background-shades-50 ${item?.disabled ? 'disable-card-item' : 'background-hover-shades-100'}`}
            >
                <div className="row align-items-center">
                    <div className={`col-8 col-lg-10  pr-0`}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div><IconMealBowl className="mr-8px mb-1" /></div>
                            <div className={`flex-grow-1 minw-0`}>
                                <CustomTooltip
                                    text={item?.fullName}
                                    classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                                    showIfTruncated={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col-4 col-lg-2'>
                        <div className={"d-flex justify-content-end"}>
                            <PlusIconsOptions
                                className={`plus-icons-options icon-color-shades-400`}
                                onClick={() => onAdd(item)}
                            />
                        </div>
                    </div>
                </div>
            </CustomCard>
        </>
    );
}

export default CafeteriaCard
